import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { format, isValid, parseISO } from 'date-fns';

const OrdersByDayChart = ({ data }) => {
  const formatted = data.map(d => {
    let label = 'N/A';
    if (d.date) {
      const parsedDate = parseISO(d.date);
      if (isValid(parsedDate)) {
        label = format(parsedDate, 'MMM dd'); // e.g. "Jun 20"
      }
    }
    return {
      name: label,
      value: d.total_orders ?? 0
    };
  });

  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={formatted}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="value" fill="#3b82f6" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default OrdersByDayChart;
